module.exports = __webpack_public_path__ + "static/media/delivered.a7190aa8.svg";